module.exports = __webpack_public_path__ + "static/media/CM_Logo.b171b0f5.png";